import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { environment } from '@environments/environment';
import { CountryCode } from '@ibe.models/country-code.model';
import { SidebarService, ModalService } from '@ibe/services/ui';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
// import { Passenger } from '@ibe.models/passenger.model.lib';
import * as fromStore from '../../../../store';

import { SelectInputOption } from '@ibe.components/common/inputs/select-input-indra/models/select-input-option';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';

import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as Actions from '../../../../store/actions/user.actions';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import * as MilesBarActions from '@ibe/store/actions/miles-bar.actions';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';

import { INDRACustomerAccountService } from '@ibe.services/customer-account.indra.service';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';

import * as _ from 'lodash';

import { 
	INDRA_CA_STATES_URL, 
	INDRA_US_STATES_URL, 
	INDRA_BR_STATES_URL, 
	INDRA_AU_STATES_URL, 
	INDRA_AR_STATES_URL,
	UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYWITHMILES_CHECKBOX,
	UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE,
	UPGRADE_ACCOUNT_SIDEBAR_SOURCE_MG_BOTTOM_BAR,
	UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS
} 
from '@ibe.config';

@Component({
	selector: 'app-upgrade-miles-and-go',
	templateUrl: './upgrade-miles-and-go.indra.component.html',
	styleUrls: ['./upgrade-miles-and-go.component.scss']
})
export class INDRAUpgradeMilesAndGoComponent implements OnInit, OnDestroy {

	private isAlive = true;
	triedToSubmit = false; // To know if we should show errors or not

	countryCodes$: Observable<Array<CountryCode>> = this.store.select(fromStore.getCountryCodes);

	infoLoaded = true;
	countryCodes;
	@ViewChild('sidebar') $sidebar: ElementRef;

	userInfo$ = this.store.pipe(select(fromStore.getUserInfo));
	userInfo: any;
	form: FormGroup;
	userCountry: string = 'cenas';
	
	/*
	hasChanges: boolean = false;
	hasChanges$ = Observable.create(observer => {
		this.form.valueChanges.pipe(takeWhile(() => this.isAlive)).subscribe(values => {
			const changes = Object.keys(values).filter(key => values[key] != this.formOld[key]);
			observer.next(changes.length > 0);
		});
	});
	*/
	
	confirmModalCallback$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
	confirmModalCallback = '';

	formOld: any;
	countriesWithStateValues = ['BR', 'CA', 'US', 'AU', 'AR'];
	stateCodes = [];
	stateCodesUS = [];
	stateCodesCA = [];
	stateCodesBR = [];
	stateCodesAU = [];
	stateCodesAR = [];
	stateOptions = Array<SelectInputOption>();
	consentsToAdd= [];
	consentsToRevoke = [];
	showError: boolean = false;
	errorMessage: any;
	sidebarSource;
	isLoading: boolean = false;

	constructor(
		protected _http: HttpClient,
		private store: Store<fromStore.State>,
		private sidebar: SidebarService,
		private customerAccountService: INDRACustomerAccountService,
		private fb: FormBuilder,
		private modalService: ModalService,
		private ibeAdminService: INDRAIbeAdminService,
		private sidebarService: SidebarService,
		private milesService: INDRAMilesService,
		private storage: INDRAStorageService
	) {
		// Initialize countryCodes variable
		this.getCountryCodes();
		this.INDRA_createForm();

		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(async data => {
				this.userInfo = data;
				this.userCountry = data.country;

		this.form.statusChanges
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(status => {
				if (status === 'VALID') {
					this.formOld = { ...this.form.value };
				}
            });
		});
		
		this.confirmModalCallback$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.confirmModalCallback = value;
				}
			});
			
		const sidebarItems = this.sidebarService.getSidebarParameters();
		if (sidebarItems !== null && sidebarItems.length > 0 && sidebarItems[0] !== null) {
			this.sidebarSource = sidebarItems[0].source;
		}
	}

	ngOnInit() {
		this.formOld = { ... this.form.value };
	}

	async INDRA_createForm() {
		this.form = this.fb.group({
			cpf: [null],
			nif: [null],
			state: [null],
			communication_milesego_email: [null],
			communication_milesego_sms: [null],
			treatment_consent: [null, Validators.required],
			terms_conditions: [null, Validators.required],
		});

		await this._http.get(INDRA_US_STATES_URL).toPromise().then(
			(data: any) => {
				this.stateCodesUS = data;
			},
			err => {
				console.error(err);
			}
		);

		await this._http.get(INDRA_BR_STATES_URL).toPromise().then(
			(data: any) => {
				this.stateCodesBR = data;
			},
			err => {
				console.error(err);
			}
		);

		await this._http.get(INDRA_AU_STATES_URL).toPromise().then(
			(data: any) => {
				this.stateCodesAU = data;
			},
			err => {
				console.error(err);
			}
		);

		await this._http.get(INDRA_AR_STATES_URL).toPromise().then(
			(data: any) => {
				this.stateCodesAR = data;
			},
			err => {
				console.error(err);
			}
		);

		await this._http.get(INDRA_CA_STATES_URL).toPromise().then(
			(data: any) => {
				this.stateCodesCA = data;
			},
			err => {
				console.error(err);
			}
		);

		if (this.countriesWithStateValues.includes(this.userCountry)) {
			this.form.controls['state'].setValidators(Validators.required);

			switch (this.userCountry) {
				case 'US':
					this.stateCodes = this.stateCodesUS;
					break;
				case 'CA':
					this.stateCodes = this.stateCodesCA;
					break;
				case 'BR':
					this.stateCodes = this.stateCodesBR;
					break;
				case 'AU':
					this.stateCodes = this.stateCodesAU;
					break;
				case 'AR':
					this.stateCodes = this.stateCodesAR;
					break;
				default:
					break;
			}
			this.form.controls['state'].patchValue(null);
			this.stateCodes.forEach((item) => {
				this.stateOptions.push({
					text: item.state,
					value: item.code
				});
			});
		}
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_saveSidebar() {
		this.triedToSubmit = true;
		if (this.form.valid) {
			// this.formOld = { ... this.form.value };
			this.validateAllFormFields(this.form);
			this.triedToSubmit = false;
			let doctype = '';
			let docNumber = '';
			if (this.form.controls['cpf'].value) {
				doctype = '23';
				docNumber = this.form.controls['cpf'].value;
			} else if (this.form.controls['nif'].value) {
				doctype = '24';
				docNumber = this.form.controls['nif'].value;
			}
			this.INDRA_getConsents();

			const payload = {
				'uniqueId': this.userInfo.airlineID ? this.userInfo.airlineID : '',
				'docType': doctype ? doctype : null,
				'docNumber': docNumber ? docNumber : null,
				'docIssueCountry': this.userCountry,
				'consentsListToAdd': this.consentsToAdd,
				'consentsListToRevoke': this.consentsToRevoke,
				'upgradeToMG': true
			};
			this.isLoading = true;
			this.customerAccountService.modifyCustomerAccount(payload).subscribe(res => {
				if (res && res.status === '200') {
					this.isLoading = false;

					if (this.sidebarSource === UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYWITHMILES_CHECKBOX) {
						this.store.dispatch(new OptionsBarActions.PutPriceUnit('miles'));
						this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(true));
					}
					
					// update user info on the store and session storage with the frequent flyer details
					const userInfoBean = res.userProfileBean;
					if (userInfoBean) {
						const updatedUserInfo = _.cloneDeep(this.userInfo);
						updatedUserInfo['ffLevel'] = userInfoBean.ffLevel;
						updatedUserInfo['ffCarrier'] = userInfoBean.ffCarrier;
						updatedUserInfo['ffNumber'] = userInfoBean.ffNumber;
						updatedUserInfo['currentPoints'] = userInfoBean.currentPoints;
						this.store.dispatch(new Actions.PutUserInfoAction(updatedUserInfo));
						
						
						const userData = _.cloneDeep(this.storage.get('userData'));
						userData['ffLevel'] = userInfoBean.ffLevel;
						userData['ffCarrier'] = userInfoBean.ffCarrier;
						userData['ffNumber'] = userInfoBean.ffNumber;
						userData['currentPoints'] = userInfoBean.currentPoints;
						userData['userProfile']['ffLevel'] = userInfoBean.currentPoints;
						userData['userProfile']['ffLevel'] = userInfoBean.ffLevel;
						userData['userProfile']['ffCarrier'] = userInfoBean.ffCarrier;
						userData['userProfile']['ffNumber'] = userInfoBean.ffNumber;
						this.storage.set('userData', userData);
					}

					this.consentsToAdd = [];
					this.consentsToRevoke = [];

					// this.TAP_closeSidebar();
					this.sidebar.closeSidebar();
				} else if (res.errors && res.errors.length > 0) {
					this.isLoading = false;
					if (res.errors[0] && res.errors[0].desc) {
						const error = res.errors[0].desc.split('-');
						if (error && error.length > 0) {
							if ((error[1] && error[1].trim() === 'CPF or NIF already exist. Update document if necessary.') || (error[2] && error[2].trim() === 'Invalid Fiscal ID')) {
								if (payload.docType === '23') {
									this.errorMessage = this.INDRA_getTranslation('createAccountSidebar.upgrade.text.invalidCPFDesc');
								} else if (payload.docType === '24') {
									this.errorMessage = this.INDRA_getTranslation('createAccountSidebar.upgrade.text.invalidNIFDesc');
								}
							} else {
								this.errorMessage = res.errors[0].desc;
							}
						} else {
							this.errorMessage = res.errors[0].desc;
						}
						this.showError = true;
						this.INDRA_scrollToError();
					} else {
						this.isLoading = false;
						this.errorMessage = this.INDRA_getTranslation('createAccountSidebar.text.pleaseTryAgain');
						this.showError = true;
						this.INDRA_scrollToError();
					}
				} else {
					this.isLoading = false;
					this.errorMessage = this.INDRA_getTranslation('createAccountSidebar.text.pleaseTryAgain');
					this.showError = true;
					this.INDRA_scrollToError();
				}
				// this.closeSidebar();
			},
			err => {
				if (err) {
					this.isLoading = false;
					this.showError = true;
					this.errorMessage = err;
				}
			});
		} else {
			this.INDRA_scrollToError();
		}
    }

	INDRA_close(event) {
		if (event) {
			this.showError = false;
		}
	}
    
    INDRA_getConsents() {
		this.consentsToAdd = [];
		this.consentsToRevoke = [];
		
		if (this.form.controls['terms_conditions'].value) {
			this.consentsToAdd.push('LOYTC', 'TAPPP');
		} else {
			this.consentsToRevoke.push('LOYTC', 'TAPPP');
		}
		if (this.form.controls['treatment_consent'].value === 'yes') {
			this.consentsToAdd.push('TAPPROF');
		} else {
			this.consentsToRevoke.push('TAPPROF');
		}
		if (this.form.controls['communication_milesego_email'].value) {
			this.consentsToAdd.push('LOYEMAIL');
		} else {
			this.consentsToRevoke.push('LOYEMAIL');
		}
		if (this.form.controls['communication_milesego_sms'].value) {
			this.consentsToAdd.push('LOYSMS');
		} else {
			this.consentsToRevoke.push('LOYSMS');
		}
	}

	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			if (control instanceof FormControl) {
				// control.markAsTouched({ onlySelf: true });
				control.markAsUntouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.validateAllFormFields(control);
			}
		});
	}

	INDRA_scrollToError() {
		const sidebar: any = this.$sidebar.nativeElement;
		// const sidebarScrollPosition = sidebar.scrollTop;

		setTimeout(() => {
			sidebar.scrollTo({
				left: 0,
				top: 0,
				behavior: 'smooth'
			});
		}, 100);
	}

	INDRA_closeSidebar() {
		if (this.sidebarSource === UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE) {
			this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('createAccountSidebar.upgrade.title.notCreateMilesGoAccount')));
			this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.loseDiscount') + 
				this.INDRA_getTranslation('createAccountSidebar.upgrade.text.priceChange')));
			this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.createMilesGoAccount')));
			this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.continueWithoutDiscount')));
			
		} else if (this.sidebarSource === UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS) {
			this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('createAccountSidebar.upgrade.title.cantPayFlightWithMiles')));
			this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.notPayFlightAndExtrasWithMiles')));
			this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.createMilesGoAccount')));
			this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.continueWithoutMGAccount')));
			
		} else {
			this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('createAccountSidebar.upgrade.title.cantPayFlightWithMiles')));
			this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.youChooseNotToUpgrade')));
			this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.backToPayingWithCash')));
			this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('createAccountSidebar.upgrade.text.upgradeToMilesGo')));
		}
		
		this.modalService.assignComponent(INDRAConfirmModalComponent);
		this.modalService.open();

		this.modalService.isOpen
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (!value) {
					if (this.confirmModalCallback === 'ok') {
						this.store.dispatch(new ConfirmModalActions.ResetAction);
					} else {
						if (this.sidebarSource === UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE) {
							this.INDRA_removeMilesGoDiscount();
						} else {
							this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
						}
						this.sidebar.closeSidebar();
					}
				}
			});
	}
	
	INDRA_removeMilesGoDiscount() {
		this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ miles: 0, cash: 0 }));
		this.store.dispatch(new MilesBarActions.SetDiscount(0));
		this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction([]));
		this.milesService.INDRA_updateMiles(0);
	}

	trackByFn(index, item) {
		return index; // or item.id
	}


	/**
	 * Get list of countries with phone codes from file
	 */
	getCountryCodes(): void {
		const URL = './assets/data/country_codes.json';
		const filePromise = this._http.get(URL).toPromise();

		filePromise.then(
			(data: any) => {
				this.countryCodes = data;
			},
			err => {
				console.error(err);
			}
		);
	}

	INDRA_hasErrors(control) {
		return control.invalid && this.triedToSubmit;
	}

	INDRA_hasErrorsClasses(control, $event = null) {
		return this.INDRA_hasErrors(control) ? 'has-error' : '';
	}
	
	INDRA_printPassengerTitle() {
		if (this.userInfo && this.userInfo.title) {
			return this.userInfo.title;
		}
	}

	INDRA_printPhoneType() {
		let type = '';
		if (this.userInfo.contactPhone && this.userInfo.contactPhone.phoneType) {
			switch (this.userInfo.contactPhone.phoneType) {
				case '6':
					type = this.INDRA_getTranslation('createAccountSidebar.text.home');
					break;
				case '10':
					type = this.INDRA_getTranslation('createAccountSidebar.text.mobile');
					break;
				case '7':
					type = this.INDRA_getTranslation('createAccountSidebar.text.business');
					break;
			}
		}
		return type;
	}
	
	INDRA_printPhoneNumber() {
		if (this.countryCodes && this.userInfo.contactPhone) {
			const FILTERED_COUNTRY_CODE = this.countryCodes.filter(
				country =>
					country.code ===
					this.userInfo.contactPhone.countryCode
			);
			if (FILTERED_COUNTRY_CODE.length === 1) {
				return (
					FILTERED_COUNTRY_CODE[0].dial_code +
					' ' +
					this.userInfo.contactPhone.number
				);
			}
			return this.userInfo.contactPhone.number;
		}
		return;
	}
	

	INDRA_Errors(control, field = null) {
		const errors = [];

		if (control.hasError('required')) {
			errors.push(`${field} ${this.INDRA_getTranslation('createAccountSidebar.text.isRequired')}`);
		}

		if (control.hasError('email')) {
			errors.push(`${field} ${this.INDRA_getTranslation('createAccountSidebar.text.isNotValid')}`);
		}

		if (control.hasError('MatchPassword')) {
			errors.push(`${this.INDRA_getTranslation('createAccountSidebar.text.passwordNotMatch')}`);
		}

		if (control.hasError('pattern') && field != 'Password') {
			errors.push(`${field} ${this.INDRA_getTranslation('createAccountSidebar.text.isNotValid')}`);
		}

		if (control.hasError('pattern') && field == 'Password') {
			errors.push(`${this.INDRA_getTranslation('createAccountSidebar.text.mustContainAtLeast')}`);
		}

		return errors.join('; ');
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

}
